<template>
    <div class="page" id="offer">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/offers.png" />
        </header>

        <div class="scroller2 green">
            <div class="" v-if="!offer">
                <pre-loader-item v-for="n in 5" :key="n" />
            </div>

            <div v-else>
                <div class="pageHeaderIntro">
                    <h2 style="line-height: 28px; width: calc(100% - 30px)">
                        {{ offer.title }}
                    </h2>
                    <ul class="links">
                        <li>
                            <a
                                style="color: #257961; position: absolute; right: 20px; top: 34px"
                                class="cancel"
                                @click.prevent="$router.back()"
                                href="#"
                            >
                                <x-icon class="icon" />
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="thumbnailSurround">
                    <img class="thumbnail" :src="imageURL(offer.image)" v-if="offer.image" />
                </div>

                <div class="thumbnailSurround" v-for="(image, index) in offer.images" :key="index">
                    <img class="thumbnail" :src="imageURL(image)" />
                </div>

                <div class="copy">
                    <p>{{ offer.description }}</p>
                </div>

                <span class="price">{{
                    offer.price | currency({ symbol: $store.state.user.currencySymbol })
                }}</span>

                <button
                    :disabled="busy"
                    @click.prevent="buyOffer"
                    type="button"
                    class="button center"
                >
                    {{ busy ? "Please wait..." : offer.button_type }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { XIcon } from "vue-feather-icons";
import PreLoaderItem from "@/components/App/Pre-loader-item";
import FadeImage from "@/components/App/fade-image";
import { imageURL } from "@/mixins/imageURL.js";
export default {
    name: "offer",
    mixins: [imageURL],
    components: { XIcon, PreLoaderItem, FadeImage },
    created() {
        this.getOffer();
    },
    data() {
        return {
            offer: false,
            busy: false,
        };
    },
    methods: {
        getOffer() {
            window.axios.get("/offer/" + this.$route.params.id).then((offer) => {
                this.offer = offer.data;
            });
        },
        buyOffer() {
            var $amount = this.$options.filters.currency(this.offer.price, {
                symbol: this.$store.state.user.currencySymbol,
            });

            this.$confirm(
                "Are you sure you want to purchase this offer?<br><br>This will deduct " +
                    $amount +
                    " from your payment card that we have saved on file ending " +
                    this.$store.state.user.stripe_card +
                    ".",
                () => {
                    this.busy = true;
                    window.axios
                        .post("/offer/" + this.$route.params.id + "/redeem")
                        .then((response) => {
                            if (response.data.type == "error") {
                                this.$notify({
                                    type: "error",
                                    text: response.data.msg,
                                });
                            }

                            if (response.data.type == "success") {
                                this.$notify(response.data.msg);
                            }
                        })
                        .finally(() => {
                            this.busy = false;
                        });
                },
                "Yes",
                "No, cancel",
            );
        },
    },
};
</script>

<style lang="scss" scoped>
#offer {
    .thumbnail {
        border-radius: 12px;
        width: 100%;
        margin-bottom: 20px;
    }
    .copy {
        background: white;
        padding: 20px;
        border-radius: 12px;
        color: $green_0;
        white-space: pre-line;
        margin-bottom: 20px;
        line-height: 1.5;
        overflow-wrap: break-word;
        word-wrap: break-word;
        -ms-word-break: break-all;
        word-break: break-all;
        word-break: break-word;
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
    }
    .price {
        font-size: 26px;
        color: $green_0;
        margin: 30px;
        text-align: center;
        display: block;
    }
}
</style>
